import React, { useEffect } from "react";
import ProgramListAccordian from "./ProgramListAccordian";
import MyProgrammeAccordian from "./MyProgrammeAccordian";
const NewProgramList = (props) => {
  const {programData,userProgramData,condition, refreshProgramList} = props;
  const user = localStorage.getItem('user');
  
  useEffect(() => {
    if (refreshProgramList) {
      refreshProgramList();
    }
  }, [user, refreshProgramList]);
  
  return (
    <div >
      <div className="prg-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="myprogram othersprogram">
                {user && (
                  <>
                    <h2 class="font-30 black-txt-light mt-34 mb-32 font-semibold">My Programmes</h2>
                    {user && userProgramData && userProgramData.length === 0 && (
                      <p className="font-qregular font-20 black-txt-light m-b-60">
                        You've not yet started any programmes on Kidney Beam. Take a look
                        below and get started today. If you're not sure where to start
                      please feel free to email us at hello@kidneybeam.com.
                    </p> 
                    )}
                    {user && userProgramData && userProgramData.length > 0 && (
                      <MyProgrammeAccordian key='100' programList={userProgramData} condition={condition}/>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="othrprg-section p-b-60">
        <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="othersprogram m-t-60">       
                  { userProgramData && userProgramData.length === 0 &&(
                    <>
                      <h2 className="font-30 black-txt-light mb-32 font-semibold">Browse Programmes</h2>
                    </>
                  )}
                  {userProgramData && userProgramData.length > 0 && (
                    <>
                      <h2 class="font-30 black-txt-light mb-32 font-semibold">Other Programmes</h2>
                    </>
                  )}
                  { !user &&(
                    <>
                      <h2 className="font-30 black-txt-light mb-32 font-semibold">Browse Programmes</h2>
                    </>
                  )}
                  {programData && programData.length > 0 && (
                    <div>
                      {programData.map((program, index) => (
                        <div key={index}>
                          <h3 class="font-24 black-txt-light fw600 mb-32 font-medium mt-32">{program.title}</h3>
                          <ProgramListAccordian index={index} programList={program} condition={condition} refreshProgramList={refreshProgramList}/>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};

export default NewProgramList;
